import SessionEventProto from "../session-event-proto"
import moduleClockInOut_initCustomView from "../../modules/clock-in-out/actions/init-custom-view"

const debug = false
// const debug = "EventCompanyUsersDelta"

export default class EventCompanyUsersDelta extends SessionEventProto {

    private header : {}

    constructor(sessionEvent: any) {
        super(sessionEvent)

        this.header     = {}
        this.method     = sessionEvent.method
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        if (this.isDifferentCompany()) return false;

        // update session
        // check if any fields we care about there

        const companyUserId = this.data.companyId+"-"+this.data.userId;
        const companyUser = gd.session.companyUsers.get(companyUserId);

        if (!companyUser) {
            console.error("not company user found #jjd882s")
            return
        }

        const setWorkdayDuration = (index: number, value: number) => {
            const workdayDurations = _.clone(companyUser.workdayDurations)
            workdayDurations[index] = value
            companyUser.workdayDurations = workdayDurations
        }

        _.forOwn(this.data, (value: any, key: string)=>{
            if (key === 'userId') return;
            if (key === 'companyId') return;

            switch (key) {
                case 'workWeekMon'      : setWorkdayDuration(0, value); break
                case 'workWeekTue'      : setWorkdayDuration(1, value); break
                case 'workWeekWed'      : setWorkdayDuration(2, value); break
                case 'workWeekThu'      : setWorkdayDuration(3, value); break
                case 'workWeekFri'      : setWorkdayDuration(4, value); break
                case 'workWeekSat'      : setWorkdayDuration(5, value); break
                case 'workWeekSun'      : setWorkdayDuration(6, value); break

                case 'autoClockOutTime' :
                    companyUser.setAutoClockOutTimeFromUTC(value);
                    break


                default:
                    // @ts-ignore
                    companyUser[key] =  value
            }
        });


        if (this.data.hasOwnProperty('clockInOutEnabled') && companyUser?.userId === gd.user.id ) {
            debug && console.log(debug, 'process clockInOutEnabled')
            // patch dynamic custom views
            moduleClockInOut_initCustomView()
        }

        this._sendBusUpdate()

    }

    _sendBusUpdate() {
        debug && console.log(debug, '_sendBusUpdate', this.data)

        // send
        const companyUserId = this.data.companyId+"-"+this.data.userId
        gd.modelBus.newUpdate('company-user', this.method, companyUserId, this.data, this.header)
    }
};

